const React = require('react')

import {
  Button,
  Col,
  Glyphicon,
  Image,
  Label,
  OverlayTrigger,
  Panel,
  Row,
  Tooltip,
} from 'react-bootstrap'
import gtagHelper from '../../utils/gtagHelper'
import SiteModal from './SiteModal'
const TextTruncate = require('react-text-truncate')
const basePath = window.basePath || '';

export default class Site extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      isErrorImage: false
    }
    this.handleAdd = this.handleAdd.bind(this)
    this.handleHideModal = this.handleHideModal.bind(this)
    this.handleShowModal = this.handleShowModal.bind(this)
  }

  handleShowModal() {
    gtagHelper.sendSitePreviewEvent(this.props.site, this.props.tags)
    this.setState({
      showModal: true
    })
  }

  handleHideModal() {
    this.setState({
      showModal: false
    })
  }

  handleAdd() {
    this.setState({
      showModal: false
    }, this.props.onAdd)
  }

  setErrorImage = () => {
    this.setState({
      ...this.state,
      isErrorImage: true
    })
  }

  render() {
    const tooltipText = this.props.item.download_count == 0
    ? `Be the first to try this site!`
    : `${this.props.item.download_count} user(s) have downloaded this site`
    return (
      <Panel style={{ height: '380px', position: 'relative' }}>
        <Panel.Body>
          {this.state.showModal &&
            <SiteModal
              onHide={this.handleHideModal}
              item={this.props.item}
              show={this.state.showModal}
              site={this.props.site}
              tags={this.props.tags}
              thumbnails={this.props.pageThumbnails}
              source={this.props.source}
            >
            {this.props.source == 'lessonplanner' &&
              <Button
                bsStyle='success'
                onClick={this.handleAdd}>
                + Add Lesson Plan
              </Button>
            }
            {!this.props.item.is_owned && this.props.source != 'lessonplanner' &&
              <Button
                bsStyle='success'
                onClick={this.handleAdd}>
                  + Add
              </Button>
            }
            {this.props.item.is_owned && this.props.source != 'lessonplanner' &&
              <Button
                bsStyle='success'
                onClick={this.handleAdd}>
                <Glyphicon glyph='ok'/>&nbsp;
                Added
              </Button>
            }
            </SiteModal>
          }
          <a
            href="javascript:;"
            onClick={this.handleShowModal}>
            {!this.props.mainThumbnail &&
            <Image
              className='img'
              style={{ margin: '0 auto' }}
              src={`${basePath}/img/placeholder.png`}
              responsive
              rounded
              width={255}
              height={169}
            />
            }
            {this.props.mainThumbnail &&
            <Image
              className='img'
              // make it all image thumbnail into standard height in lesson boost thumbnail image's height is 215.125px
              style={{ margin: '0 auto', width: '100%', height: 208.125 }} 
              onError={this.setErrorImage}
              src={!this.state.isErrorImage?this.props.mainThumbnail.url:`${basePath}/img/placeholder.png`}
              responsive
              rounded
              width={255}
              height={169}
            />
            }
          </a>
          <h5 style={{height:'30px'}}>
            <a
              href="javascript:;"
              onClick={this.handleShowModal}>
              <TextTruncate
                line={2}
                text={this.props.site.title}
              />
            </a>
          </h5>
          <div style={{display: 'block', height: '40px'}}>
            <TextTruncate
              line={1}
              text={this.props.site.author_name}
            />
            <small>
              <TextTruncate
                line={1}
                text={this.props.site.school_name}
              />
            </small>
          </div>
          <div className="container-fluid" style={{margin: '0 20px 0 0', width: '90%', position: 'absolute', bottom: '5px'}}>
            <Row>
              <Col className="pull-left">
                <Row style={{marginTop:'10px'}}>
                  <Col md={8} sm={8}>
                    <OverlayTrigger
                      overlay={<Tooltip id={`tooltip-${this.props.item.id}`}>{tooltipText}</Tooltip>}
                    >
                      <Label bsStyle='default'>
                        <Glyphicon glyph="save" />
                        {
                          this.props.item.download_count
                          ? ` ${this.props.item.download_count}`
                          : ''
                        }
                      </Label>
                    </OverlayTrigger>
                  </Col>
                </Row>
              </Col>
              <Col className="pull-right">
              { !this.props.item.is_owned && this.props.source != 'lessonplanner' &&
                <Button bsStyle='primary' onClick={this.handleShowModal}>View</Button>
              }
              { this.props.item.is_owned && this.props.source != 'lessonplanner' &&
                <Button
                  bsStyle='success'
                  onClick={this.handleShowModal}>
                  <Glyphicon glyph='ok'/>&nbsp;
                  Added
                </Button>
              }
              {this.props.source == 'lessonplanner' &&
                <Button bsStyle='primary' onClick={this.handleShowModal}>Add Lesson Plan</Button>
              }

              </Col>
            </Row>
          </div>
        </Panel.Body>
      </Panel>
    )
  }
}